export class ImpactAssessment {
  id: number;
  updatedDB_Id: number;
  geography: string;
  mappingID: string;
  country: string;
  regulator: string;
  updatedDB_Date: Date;
  pubType: string;
  title: string;
  description: string;
  hyperlink: string;
  ruleTopic: string;
  linkedRules: string;
  linkedRulesByRegulator: string;
  linkedPolicies: string;
  linkedRisks: string;
  linkedProcesses: string;
  category: string;
  ruleType: string;
  applicationDate: Date | null;
  legalEntity: string;
  jurisdiction: string;
  previousImpactAsss_Id: string;
  assessmentTeam: string;
  assessor: string;
  assessorDelegate: string;
  assessmentDueDate: Date | null;
  assessmentLastEdited: Date | null;
  assessmentStatus: string;
  impactRating: string;
  impactScore: number;
  implementationType: string;
  assessmentDetails1: string;
  assessmentDetails2: string;
  actionRequired: string;
  reviewTeam: string;
  reviewer: string;
  reviewerDelegate: string;
  reviewDueDate: Date | null;
  reviewLastEdited: Date | null;
  reviewStatus: string;
  reviewDetails: string;
  implementationTeam: string;
  implementationOwner: string;
  ownerDelegate: string;
  implementationDueDate: Date | null;
  implementationLastEdited: Date | null;
  implementationStatus: string;
  implementationDetails: string;
  versionNumber: number;
  userId: string;
  userName: string;
  createdDateTime: Date;
  capitalRWAImpact: string;
  impactRatingLite: string;
  projectReference: string;
  nextActionStep: string;
  isHidden: boolean;
  isReviewRequired: boolean;
  isImplementationRequired: boolean;
  isRecordTime: boolean;
  timeSpent: number;
  merged_Id: string;
  isMerged: boolean;
  templateNo!: number;
  lineOfBusiness:string;
  actionsRequired:string | null;
  isSendNotification: boolean;
  assessmentDetailsList: ImpactAssessmentAssessmentDetailsList[];
  assessmentDetailsList2:ImpactAssessmentAssessmentDetailsList2[];
  isLobbyingRequired: string;
  constructor() {
    this.id = 0;
    this.updatedDB_Id = 0;
    this.geography = '';
    this.mappingID = '';
    this.country = '';
    this.regulator = '';
    this.updatedDB_Date = new Date();
    this.pubType = '';
    this.title = '';
    this.description = '';
    this.hyperlink = '';
    this.ruleTopic = '';
    this.linkedRules = '';
    this.linkedRulesByRegulator = '';
    this.linkedPolicies = '';
    this.linkedRisks = '';
    this.linkedProcesses = '';
    this.category = '';
    this.ruleType = '';
    this.applicationDate = null;
    this.legalEntity = '';
    this.jurisdiction = '';
    this.previousImpactAsss_Id = '';
    this.assessmentTeam = '';
    this.assessor = '';
    this.assessorDelegate = '';
    this.assessmentDueDate = null;
    this.assessmentLastEdited = null;
    this.assessmentStatus = '';
    this.impactRating = '';
    this.impactScore = 0;
    this.implementationType = '';
    this.assessmentDetails1 = '';
    this.assessmentDetails2 = '';
    this.actionRequired = '';
    this.reviewTeam = '';
    this.reviewer = '';
    this.reviewerDelegate = '';
    this.reviewDueDate = null;
    this.reviewLastEdited = null;
    this.reviewStatus = '';
    this.reviewDetails = '';
    this.implementationTeam = '';
    this.implementationOwner = '';
    this.ownerDelegate = '';
    this.implementationDueDate = null;
    this.implementationLastEdited = null;
    this.implementationStatus = '';
    this.implementationDetails = '';
    this.versionNumber = 0;
    this.userId = '';
    this.userName = '';
    this.createdDateTime = new Date();
    this.capitalRWAImpact = '';
    this.impactRatingLite = '';
    this.projectReference = '';
    this.nextActionStep = '';
    this.isHidden = false;
    this.isReviewRequired = false;
    this.isImplementationRequired = false;
    this.isRecordTime = false;
    this.timeSpent = 0;
    this.merged_Id = "";
    this.isMerged = false;
    this.assessmentDetailsList = [];
    this.assessmentDetailsList2 = [];
    this.lineOfBusiness = '';
    this.actionsRequired = '';
    this.isSendNotification = false;
    this.isLobbyingRequired = '';
  }
}

export class ImpactAssessmentWithStatus {
  message: string;
  isSuccess: boolean;
  impactResult!: ImpactAssessment;
  constructor() {
    this.message = "";
    this.isSuccess = false;
  }
}
export class ImpactAssessmentAssessmentDetailsList {
  actionsRequired: string;
  nextActionDate: Date | null;
  actionStatus: string;
  actionOwner: string;
  constructor() {
  this.actionsRequired= '';
  this.nextActionDate= null;
  this.actionStatus='';
  this.actionOwner='';
  }
}

export class ImpactAssessmentAssessmentDetailsList2 {
  actionsRequired: string;
  actionsTaken:string;
  nextActionDate: Date | null;
  actionStatus: string;
  actionOwner: string;
  constructor() {
    this.actionsRequired = '';
    this.actionsTaken = '';
    this.nextActionDate = null;
    this.actionStatus = '';
    this.actionOwner = '';
  }
}
